import format from "date-fns/format";
import locale from "date-fns/locale/ja";

export default function formatLocaleDate(date: Date) {
  return format(date, "PPP(E)", { locale });
}
